"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Tooltip = _interopRequireDefault(require("../Tooltip"));
var _default2 = _interopRequireDefault(require("../locales/default"));
var _LocaleContext = require("../locales/LocaleContext");
var _excluded = ["visible", "children"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var ValidationTooltip = /*#__PURE__*/function (_Component) {
  function ValidationTooltip() {
    (0, _classCallCheck2.default)(this, ValidationTooltip);
    return _callSuper(this, ValidationTooltip, arguments);
  }
  (0, _inherits2.default)(ValidationTooltip, _Component);
  return (0, _createClass2.default)(ValidationTooltip, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        visible = _this$props.visible,
        children = _this$props.children,
        rest = (0, _objectWithoutProperties2.default)(_this$props, _excluded);
      return /*#__PURE__*/_react.default.createElement(_LocaleContext.LocaleReceiver, {
        componentName: "NumberInput",
        defaultLocale: _default2.default.NumberInput
      }, function (localeCode, locale) {
        return /*#__PURE__*/_react.default.createElement(_Tooltip.default, (0, _extends2.default)({}, rest, {
          placement: 'top',
          overlay: locale.numericValidationError,
          visible: visible,
          trigger: []
        }), children);
      });
    }
  }]);
}(_react.Component);
ValidationTooltip.defaultProps = {
  visible: false
};
ValidationTooltip.propTypes = {
  visible: _propTypes.default.boolean,
  children: _propTypes.default.element
};
var _default = exports.default = ValidationTooltip;